import CourseGradeReportData from './CourseGradeReportData';

export default CourseGradeReportData;
export * from './CourseGradeReportConstant';
